const LK_Close =({color,width,height})=>{
    return(
    <svg id="Layer_1" data-name="Layer 1" fill={color} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
    {/* <defs>
      <style>
        .cls-1 {
          fill: #005c8e;
          stroke-width: 0px;
        }
      </style>
    </defs> */}
    <path class="cls-1" d="M71.77,58.5l41.9-41.9h0s0,0,0,0c1.83-1.83,1.83-4.81,0-6.64L103.71,0l-45.22,45.22L16.59,3.32c-1.83-1.83-4.8-1.83-6.64,0h0s0,0,0,0L0,13.28l45.22,45.22L3.31,100.4h0s0,0,0,0c-1.83,1.83-1.83,4.8,0,6.63,0,0,0,0,0,0l9.96,9.96,45.22-45.22h.01s41.9,41.91,41.9,41.91c1.83,1.83,4.8,1.83,6.64,0h0s0,0,0,0l9.96-9.96-45.22-45.22ZM103.71,110.87l-3.55-3.55-38.61-38.61-3.06-3.06-3.06,3.06h-.01S13.26,110.86,13.26,110.86l-3.6-3.6h0s-3.54-3.54-3.54-3.54l3.55-3.55,38.61-38.61,3.06-3.06-3.06-3.06L6.12,13.28l3.6-3.6,3.55-3.55,3.55,3.55,38.61,38.61,3.06,3.06,3.06-3.06L103.71,6.13l3.6,3.6,3.55,3.55-3.55,3.55-38.61,38.61-3.06,3.06,3.06,3.06,42.16,42.16-3.6,3.6-3.55,3.55Z"/>
  </svg>
    );
};

export default LK_Close;